
export default {
  name: 'app',
  data() {
    return {
      access_token: '',
      currentView: 'loginForm',
      authUser: null,
      companyId: null,
    };
  },
  created() {
    const token = localStorage.getItem('access_token');
    const authUser = localStorage.getItem('authUser');
    this.access_token = token || '';
    this.authUser = authUser ? JSON.parse(authUser) : null;
    if (!this.access_token || !this.authUser) {
      this.redirect(`${process.env.START_URL}/`);
    }
    this.$router.beforeEach((to, from, next) => {
      console.log('router', to, from);
      if (!to.name) {
        // this.$router.push({ name: 'Home' });
        next({ name: 'Home' });
        return;
      }
      if (to.name.indexOf(' SuperUser') + 1 &&
        (this.authUser && this.authUser.role !== 'superuser')) {
        next({ name: 'Home' });
        return;
      }

      if (this.authUser && this.authUser.role === 'superuser') {
        // if (to.name === 'Add Company SuperUser' && to.params && false) {
        //   next({ name: 'Add Company SuperUser', params: {} });
        //   return;
        // }

        // If the superuser is going to the login or logout page, let him pass safely
        if (to.name.indexOf('logout') !== -1 || to.name.indexOf('login') !== -1) {
          next({ name: name, params: params });
          return;
        }

        let name = to.name;
        let params = to.params;
        console.log('route', name, params);
        if (to.name.indexOf(' SuperUser') === -1) {
          name = `${name} SuperUser`;
          next({ name: name, params: params });
          return;
        }
        if (params.companyId) {
          // this.$router.push({ name: name, params: params });
          next();
          return;
        }
        if (!params.companyId && name !== 'Add Company SuperUser' && name !== 'Companies SuperUser') {
          params.companyId = from.params.companyId;
          if (!params.companyId) {
            name = 'Companies SuperUser';
          }
        } else {
          next();
          return;
        }
        next({ name: name, params: params });
        return;
        // if (to.name.indexOf(' SuperUser') === -1) {
        //   if (from.params.companyId) {
        //     to.params.companyId = from.params.companyId;
        //   }
        //   this.$router.push({ name: `${to.name} SuperUser`, params: to.params });
        //   next();
        //   return;
        // } else {
        //   if (!to.params.companyId && to.name !== 'Add Company SuperUser' ) {
        //     to.params.companyId = from.params.companyId;
        //     // this.$router.push({ name: `${to.name}`, params: { companyId: from.params.companyId } });
        //     next();
        //     return;
        //   }
        // }
      }
      next();
    });
    this.checkAccess();

  },
  methods: {
    sendAuth(data) {
      this.$http.post('authorize/', { username: data[0], password: data[1], app: 'cms' },
        {
          method: 'POST',
          headers: {
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            return;
          }
          this.access_token = response.body.access_token;
          this.authUser = response.body.user;
          return response.json();
        });
    },
    onLogout(redirectedOnError = true) {
      console.log('app: logout');
      this.access_token = '';
      this.authUser = null;
      this.$route.params.redirectedOnError = redirectedOnError;
      // this.$route.router.go(process.env.START_URL + '/');
      // this.redirect(process.env.START_URL + '/');
    },
    onLogin(accessToken, authUser) {
      this.access_token = accessToken;
      this.authUser = authUser;
      console.log('login');
      if (this.authUser && this.authUser.role == 'superuser') {
        this.$router.push({ name: 'Companies SuperUser' });
      } else {
        this.$router.push({ name: 'Home' });
      }
    },
    redirect(url) {
      this.$router.push(url);
    },
    checkAccess() {
      if (!this.$route.name) {
        this.$router.push({ name: 'Home' });
        return;
      }
      if (this.$route.name.indexOf(' SuperUser') + 1 &&
        (this.authUser && this.authUser.role !== 'superuser')) {
        this.$router.push({ name: 'Home' });
        return;
      }
      if (this.authUser && this.authUser.role === 'superuser') {
        if (this.$route.name.indexOf(' SuperUser') === -1 && this.$route.name.indexOf('logout') === -1) {
          this.$router.push({ name: 'Companies SuperUser' });
          return;
        }
      }
      if (this.authUser && this.authUser.role === 'manager') {
        return;
      }
      const routeName = this.$route.name;
      switch (routeName) {
        case 'workingAreas':
        case 'User & Permissions':
        case 'Add User':
        case 'Add Admin':
        case 'Days, times, shifts':
        case 'Roles':
          this.$router.push({ name: 'Home' });
          break;
        default:
          break;
      }
    },
  },
  watch: {
    access_token(val) {
      if (val && !localStorage.getItem("remove_access_token")) {
        localStorage.setItem('access_token', val);
      } else {
        localStorage.removeItem('access_token');
        localStorage.removeItem("remove_access_token");
        this.access_token = null;
        this.$router.push({ name: 'login' });
      }
    },
    authUser(val) {
      if (val && !localStorage.getItem("remove_authUser")) {
        localStorage.setItem('authUser', JSON.stringify(val));
      } else {
        localStorage.removeItem('authUser');
        this.authUser = null;
        localStorage.removeItem("remove_authUser");
        this.$router.push({ name: 'login' });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/App.controller.js